import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';

import { IUserData } from '../../../infrastructure/interfaces';
import UsersGroups from '../../../infrastructure/UsersRoles';

export interface IAdminRouteProps extends RouteProps {
  user?: IUserData;
  component: any;
  path: string;
}

@(connect((state: any) => ({ user: state.user.data })) as any)
export default class AdminRoute extends React.Component<IAdminRouteProps>{

  render() {
    const {
      user,
      component: Component,
      ...rest
    } = this.props;
    return (
      <Route {...rest} render={(props) => {
        return user
          ? user.role === UsersGroups.admin
            ? <Component />
            : <Redirect to="/Home" />
          : <Redirect to="/Login" />;
      }} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/App/components/AdminRouter.tsx